import { Box, Flex, Text } from "@chakra-ui/react";
import FooterLeft from "./FooterLeft";
import FooterRight from "./FooterRight";

const Footer = (): JSX.Element => {
  return (
    <Box w={"100%"} px={25} py={15}>
      <Flex
        width={"100%"}
        justifyContent={{ base: "center", md: "space-around" }}
        alignItems={{ base: "space-around", md: "center" }}
        direction={{ base: "column", md: "row" }}
        gap={{ base: 100, md: 0 }}
      >
        <FooterLeft />
        <FooterRight />
      </Flex>
      <Text mt={6} textAlign={"center"} fontStyle={"italic"}>
        handcrafted by me
      </Text>
    </Box>
  );
};

export default Footer;
